export default "__VITE_ASSET__MliI6MPM__"